import * as Articles from '@/services/bb_articles';
import { get } from 'lodash';

const state = {
  all: [],
  filter: {},
  isLoading: false
};

const getters = {
  all: state => state.all,
  isLoading: state => state.isLoading
};

const mutations = {
  SET_ARTICLES(state, payload) {
    state.all = payload;
  },

  SET_FILTERS(state, payload) {
    state.filter = payload;
  }
};

const actions = {
  async GET_ARTICLES({ commit, state }) {
    state.isLoading = true;

    try {
      const response = await Articles.getArticles(state.filter);
      const data = get(response, 'data');

      if (data) {
        commit('SET_ARTICLES', data);
      }
      state.isLoading = false;
    } catch (error) {
      state.isLoading = false;
      throw new Error(error);
    }
  }
};

export const MODULE_NAME = 'bb_articles';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
